import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/auth.store';

interface Props {
  children: React.ReactElement;
}

export function ProtectedRoute({ children }: Props): React.ReactElement {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/auth/register" state={{ from: location }} replace />;
  }

  return children;
}

export function AdminRoute({ children }: Props): React.ReactElement {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/auth/register" state={{ from: location }} replace />;
  }

  if (user?.role !== 'admin') {
    return <Navigate to="/marketplace/offers" replace />;
  }

  return children;
}
